'use client';

import { type FC, useState } from 'react';
import { Button } from '@paypoteam/ui-components';
import parse from 'html-react-parser';

import { Caption } from '@/components/atoms/Typography/Caption';

import type { DataProtectionInfoProps } from '../BusinessContactForm.types';

const DataProtectionInfo: FC<DataProtectionInfoProps> = ({
    config,
    className,
}) => {
    const [isAdditionalTextVisible, setIsAdditionalTextVisible] =
        useState<boolean>(false);

    const { mainText, additionalText } = config;

    return (
        <div className={className}>
            <Caption className="text-typo-secondary">{mainText}</Caption>

            <Button
                type="button"
                variant="ghost"
                size="s"
                className="inline-block w-fit cursor-pointer !text-2xs"
                onClick={() =>
                    setIsAdditionalTextVisible(prevState => !prevState)
                }
                data-test-id="data-protection-additional-info-button"
            >
                {isAdditionalTextVisible ? (
                    <>Zwiń &#9652;</>
                ) : (
                    <>Rozwiń &#9662;</>
                )}
            </Button>

            {isAdditionalTextVisible &&
                additionalText.map(({ text, id }) => (
                    <Caption
                        key={id}
                        className="mt-4 text-typo-secondary"
                    >
                        {parse(text)}
                    </Caption>
                ))}
        </div>
    );
};

export default DataProtectionInfo;
